var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBellNoNotifications(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 3V3.28988C12.8915 4.15043 15 6.82898 15 10V17H16V19H0V17H1V10C1 6.82898 3.10851 4.15043 6 3.28988V3C6 1.89543 6.89543 1 8 1C9.10457 1 10 1.89543 10 3ZM3 17H13V10C13 7.23858 10.7614 5 8 5C5.23858 5 3 7.23858 3 10V17ZM10 21V20H6V21C6 22.1046 6.89543 23 8 23C9.10457 23 10 22.1046 10 21Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 6,
    r: 6,
    fill: "#027EFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellNoNotifications);
export default __webpack_public_path__ + "static/media/bell-no-notifications.726bad15c4849948840ea9260bbb140d.svg";
export { ForwardRef as ReactComponent };